// define this week reducers.
import TopMenuConst from '../constants/top_menu.constants';

const TopMenuReducer = (state = {}, action) => {
  // console.log("MyworkDetailsReducer");
  const initialState = state;
  switch (action.type) {
    case TopMenuConst.TOPMENU_UPDATE_ACTIVE:
      Object.keys(initialState).forEach((key) => {
        if (typeof initialState[key] !== 'undefined' && initialState[key] && typeof initialState[key]['isActive'] !== 'undefined') {
          initialState[key].isActive = false;
        }
      });
      if (action.menuName) {
        if (typeof initialState[action.menuName]?.isActive !== 'undefined') {
          initialState[action.menuName].isActive = true;
        }
      }
      state = { ...state, initialState };
      break;
    case TopMenuConst.TOPMENU_UPDATE_FAVORITES:
      if (action.key && action.values) {
        if (action.pinAction == 1) {
          initialState[action.key].favorites = action.values;
        }
        else {
          const isArray = Array.isArray(initialState[action.key].favorites)
          initialState[action.key].favorites = isArray
            ? initialState[action.key].favorites?.filter(i => i.obj_id != action.values)
            : []
        }
      }
      state = Object.assign({}, state, initialState);
      break;
    case TopMenuConst.TOPMENU_UPDATE_RECENT_ITEMS:
      let newItem;
      if (initialState[action.key] && typeof initialState[action.key].recentItems !== 'undefined') {
        if (action.key == 'mywork') {
          const isArray = Array.isArray(initialState[action.key].recentItems)
          initialState[action.key].recentItems = isArray
            ? initialState[action.key].recentItems?.filter(i => i.id != action.objectId)
            : []
          newItem = { description: action.objectName, id: action.objectId };
          initialState[action.key].recentItems.unshift(newItem);
        }
        else {
          const isArray = Array.isArray(initialState[action.key].recentItems)
          initialState[action.key].recentItems = isArray
            ? initialState[action.key].recentItems?.filter(i => !(i.object_id == action.objectId && i.object_type == action.objectType))
            : []
          newItem = { name: action.objectName, object_id: action.objectId, object_type: action.objectType };
          if(action.actionType !== "delete") {
           initialState[action.key].recentItems.unshift(newItem);
          }
        }
      }
      state = Object.assign({}, state, initialState);
      break;
    case TopMenuConst.TOPMENU_UPDATE_BOTTOM_MENU_BUTTON:
      if(action.key == "objectives"){
        initialState[action.key].showTeamObjective = action.showMenu;
      } else if(action.key == "meetings"){
        initialState[action.key].showMeetNow = action.showMenu;
      }
      state = Object.assign({}, state, initialState);
      break;
    case TopMenuConst.TOPMENU_UPDATE_OBJECT_NAME:
      if (action.key == 'mywork') {
        initialState[action.key].recentItems.map((i) => {
          if (i.id == action.objectId) {
            i.description = action.objectName;
          }
          return i;
        });
      } else {
        initialState[action.key].recentItems.map((i) => {
          if (i.object_id == action.objectId) {
            i.name = action.objectName;
          }
          return i;
        });
      }
      initialState[action.key].favorites.map((i) => {
        if (i.obj_id == action.objectId) {
          i.name = action.objectName;
        }
        return i;
      });

      state = Object.assign({}, state, initialState);
      break;

    case TopMenuConst.TOPMENU_DELETE_OBJECT:
      if (typeof initialState[action.key] !== 'undefined' && initialState[action.key]) {
        if(typeof initialState[action.key].recentItems !== 'undefined') {
          if (action.key == 'mywork') {
            const isArray = Array.isArray(initialState[action.key].recentItems)
            initialState[action.key].recentItems = isArray
              ? initialState[action.key].recentItems?.filter(i => i.id != action.objectId)
              : []
          }
          else {
            const isArray = Array.isArray(initialState[action.key].recentItems)
            initialState[action.key].recentItems = isArray
              ? initialState[action.key].recentItems?.filter(i => !(i.object_id == action.objectId && i.object_type.indexOf(action.objectType) > -1))
              : []
          }
        }
        const isArray = Array.isArray(initialState[action.key].favorites)
        initialState[action.key].favorites = isArray
          ? initialState[action.key].favorites?.filter(i => i.obj_id != action.objectId)
          : []
      }
      state = Object.assign({}, state, initialState);
      state = { ...state, initialState };
      break;

    case TopMenuConst.DUMBTHETOPMENU:
      if (typeof initialState[action.key] !== 'undefined' && initialState[action.key]) {
        initialState[action.key].favorites = action.values;
        // Object.assign({},initialState[action.key].favorites,action.values);
        state = { ...state, ...initialState };
      }
      break;
    case TopMenuConst.TOPMENU_SET_PAGE_TITLE:
      if (typeof initialState[action.key] !== 'undefined' && initialState[action.key]) {
        initialState[action.key].pageTitle = action.title;
        state = { ...state, ...initialState };
      }
      break;
    case TopMenuConst.TOPMENU_LOAD_MENU_ITEMS:
      if (Object.keys(action.items).length) {
        Object.entries(initialState).forEach(([key, value]) => {
          if (typeof action.items[key] !== 'undefined') {
            const { favorites, recent_items } = action.items[key];
            initialState[key].favorites = favorites;
            initialState[key].recentItems = recent_items;
          }
        });
        state = { ...state, ...initialState };
      }
      break;
    default:
      break;
  }
  return state;
};

export default TopMenuReducer;
